import React, { useState } from "react";
import styles from "./Registrate.module.css";
import PhoneInput from "../ui/PhoneInput";
import InputField from "../ui/InputField";
import Button from "../ui/Button";

const Registrate = ({ onClick, isRegistrate }) => {
    const [registrateData, setRegistrateData] = useState({
        surname: "",
        name: "",
        email: "",
        phone: ""
    });

    const [errors, setErrors] = useState({
        surname: "",
        name: "",
        email: "",
        phone: "",
        agreement: "",
        agreementPolicy: "",
    });

    const [isAgreed, setIsAgreed] = useState(false);
    const [isAgreedPolicy, setIsAgreedPolicy] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validatePhone = (phone) => {
        return phone && phone.length === 11; // 11 цифр (7XXXXXXXXXX)
    };

    const handleInputChange = (field, value) => {
        setRegistrateData(prev => ({
            ...prev,
            [field]: value
        }));

        // Сбрасываем ошибку при изменении поля
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ""
            }));
        }
    };

    const handleAgreementChange = (e) => {
        setIsAgreed(e.target.checked);
        if (errors.agreement) {
            setErrors(prev => ({
                ...prev,
                agreement: ""
            }));
        }
    };

    const handleAgreementPolicyChange = (e) => {
        setIsAgreedPolicy(e.target.checked);
        if (errors.agreementPolicy) {
            setErrors(prev => ({
                ...prev,
                agreementPolicy: ""
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!registrateData.surname.trim()) {
            newErrors.surname = "Пожалуйста, введите фамилию";
            isValid = false;
        }

        if (!registrateData.name.trim()) {
            newErrors.name = "Пожалуйста, введите имя";
            isValid = false;
        }

        if (!registrateData.email || !validateEmail(registrateData.email)) {
            newErrors.email = "Пожалуйста, введите корректный email";
            isValid = false;
        }

        if (!registrateData.phone || !validatePhone(registrateData.phone)) {
            newErrors.phone = "Номер телефона должен содержать 10 цифр (без +7)";
            isValid = false;
        }

        if (!isAgreed) {
            newErrors.agreement = "Необходимо согласие на обработку персональных данных";
            isValid = false;
        }

        if (!isAgreedPolicy) {
            newErrors.agreementPolicy = "Необходимо согласие с условиями политики конфидиальности";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        if (validateForm()) {
            onClick(registrateData);
        }
    };

    return (
        <div className={styles.container}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <h1 className={styles.title}>Создать аккаунт</h1>

                <InputField
                    type="text"
                    label="Фамилия*"
                    value={registrateData.surname}
                    onChange={(e) => handleInputChange("surname", e.target.value)}
                    error={isSubmitted && errors.surname}
                />

                <InputField
                    type="text"
                    label="Имя*"
                    value={registrateData.name}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    error={isSubmitted && errors.name}
                />

                <InputField
                    type="email"
                    label="Электронная почта*"
                    value={registrateData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    error={isSubmitted && errors.email}
                />

                <PhoneInput
                    type="phone"
                    label="Номер телефона*"
                    value={registrateData.phone}
                    onChange={(phoneNumber) => handleInputChange("phone", phoneNumber)}
                    error={isSubmitted && errors.phone}
                />

                <Button label={"РЕГИСТРАЦИЯ"} type="submit" isSaving={isRegistrate} isSavingLabel="РЕГИСТРИРУЕМ" />

                <div className={styles.checkboxContainer}>
                    <label className={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            className={styles.checkboxInput}
                            checked={isAgreed}
                            onChange={handleAgreementChange}
                        />
                        <span className={styles.checkboxCustom}></span>
                        <a
                            href="/documents/processingOfPersonalData.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.policyLink}
                        >
                            Даю согласие на обработку персональных данных
                        </a>
                    </label>
                    {isSubmitted && errors.agreement && (
                        <p className={styles.errorText}>{errors.agreement}</p>
                    )}
                </div>

                <div className={styles.checkboxContainer}>
                    <label className={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            className={styles.checkboxInput}
                            checked={isAgreedPolicy}
                            onChange={handleAgreementPolicyChange}
                        />
                        <span className={styles.checkboxCustom}></span>
                        <a
                            href="/documents/policy.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.policyLink}
                        >
                            Я согласен с условиями политики конфидиальности
                        </a>
                    </label>
                    {isSubmitted && errors.agreementPolicy && (
                        <p className={styles.errorText}>{errors.agreementPolicy}</p>
                    )}
                </div>
            </form>
        </div>
    );
};

export default Registrate;